import { fromJS, Record } from 'immutable';
import { generateKeys, generateSchema } from '../../helpers/model.helper';
import { ITrackingAction, TrackingActionNamesEnum } from '../tracking.data';

export const TRACKING_DROPDOWN_SELECTED_SCHEMA = Object.freeze({
  DROPDOWN_IDENTIFIER: '',
  DROPDOWN_VALUE: '',
  SCREEN_NAME: '',
});
const RECORD = generateSchema(TRACKING_DROPDOWN_SELECTED_SCHEMA);
const KEYS: any = generateKeys(TRACKING_DROPDOWN_SELECTED_SCHEMA);

export class DropdownSelectedTrackingAction
  extends Record(RECORD)
  implements ITrackingAction {
  static KEYS = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get name() {
    return TrackingActionNamesEnum.dropdown_selected;
  }

  get properties() {
    return this.toJS();
  }

  setValue(value: string): DropdownSelectedTrackingAction {
    return this.set(
      KEYS.DROPDOWN_VALUE,
      value
    ) as DropdownSelectedTrackingAction;
  }
}
